import { Unit } from 'uom';
import { Units } from 'uom-units';

export const BtuPerPoundPerFahrenheit = Unit.timesNumber(
    'BtuPerPoundPerFahrenheit',
    4.18679999990745,
    Units.KilojoulePerKilogramKelvin,
);
